/**
 * Pediatrie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: PEDI
 * Catalogue acts (NGAP Maroc): 0
 */
import { defineSpecialty } from "../types";

export const pediatrie = defineSpecialty(
{
  "id": "pediatrie",
  "label": "Pediatrie",
  "short": "pediatrie",
  "scope": "Suivi de l'enfant, croissance, nutrition et posologie pédiatrique",
  "aliases": [
    "PEDI"
  ],
  "doctorSpecs": [
    "Pédiatrie",
    "Médecine générale"
  ],
  "featureFlag": "ux.v2.pediatrie",
  "theme": {
    "primary": "oklch(0.76 0.15 200)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.80 0.14 110)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "growth",
      "label": "Croissance",
      "icon": "TrendingUp",
      "route": "/clinical/growth",
      "order": 2,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 3,
      "requires": []
    },
    {
      "id": "vaccines",
      "label": "Vaccins",
      "icon": "Syringe",
      "route": "/clinical/vaccines",
      "order": 4,
      "requires": []
    },
    {
      "id": "billing",
      "label": "Cotations",
      "icon": "Receipt",
      "route": "/clinical/billing",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "growth",
      "label": "Courbes",
      "icon": "TrendingUp",
      "component": "GrowthChart",
      "order": 1,
      "requires": []
    },
    {
      "id": "vitals",
      "label": "Constantes",
      "icon": "Gauge",
      "component": "VitalSignsGrid",
      "order": 2,
      "requires": []
    },
    {
      "id": "doses",
      "label": "Posologie",
      "icon": "Pill",
      "component": "PediatricDosage",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Pédiatrie",
    "subSpecialties": [
      "Consultation",
      "Visite",
      "Vaccination",
      "Suivi de croissance"
    ],
    "catalogueActs": 0
  },
  "terminology": {
    "icd10": [
      "P00",
      "P07",
      "P20",
      "P50",
      "P90"
    ],
    "loinc": [
      "15074-8",
      "8331-1",
      "2162-6"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "infant-scale",
    "thermometer-digital"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default pediatrie;
